import { render } from "./AdvertisingMixTips.vue?vue&type=template&id=3d268cd4"
import script from "./AdvertisingMixTips.vue?vue&type=script&lang=js"
export * from "./AdvertisingMixTips.vue?vue&type=script&lang=js"

import "./AdvertisingMixTips.vue?vue&type=style&index=0&id=3d268cd4&lang=scss"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__